import { render, staticRenderFns } from "./SoundWaveStage.vue?vue&type=template&id=25f17d75&scoped=true"
import script from "./SoundWaveStage.vue?vue&type=script&lang=js"
export * from "./SoundWaveStage.vue?vue&type=script&lang=js"
import style0 from "./SoundWaveStage.vue?vue&type=style&index=0&id=25f17d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f17d75",
  null
  
)

export default component.exports